
// This promise is set in the webpack bootstrap code through json-main-template-promise-plugin.
// It will refer to native Promise if available
module.exports = window['TurnTo'].promise